/**
 * Petit défilement d'indice (mobile) : un carrousel horizontal glisse brièvement vers
 * la gauche puis revient, pour montrer qu'il se fait défiler.
 *  - grille de collection / recherche : 1er produit visible uniquement ;
 *  - fiche produit : galerie principale.
 * Une seule fois par chargement de page ; annulé au premier toucher, sans effet si
 * le carrousel n'a rien à montrer (une seule image, carrousel désactivé) ou si
 * l'utilisateur demande moins d'animations.
 */

const MOBILE_QUERY = '(max-width: 749px)';
const PEEK_RATIO = 0.2;
const OUT_MS = 520;
const HOLD_MS = 160;
const BACK_MS = 640;
const START_DELAY_MS = 700;

const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

function peek(scroller) {
  if (scroller.scrollLeft > 2) return;
  const distance = Math.min(scroller.clientWidth * PEEK_RATIO, scroller.scrollWidth - scroller.clientWidth);
  if (distance < 12) return;

  const previousSnap = scroller.style.scrollSnapType;
  const previousBehavior = scroller.style.scrollBehavior;
  let cancelled = false;
  let frame = 0;

  const restore = () => {
    scroller.style.scrollSnapType = previousSnap;
    scroller.style.scrollBehavior = previousBehavior;
    scroller.removeEventListener('touchstart', cancel);
    scroller.removeEventListener('pointerdown', cancel);
    scroller.removeEventListener('wheel', cancel);
  };
  function cancel() {
    cancelled = true;
    cancelAnimationFrame(frame);
    restore();
  }

  scroller.addEventListener('touchstart', cancel, { passive: true });
  scroller.addEventListener('pointerdown', cancel, { passive: true });
  scroller.addEventListener('wheel', cancel, { passive: true });
  scroller.style.scrollSnapType = 'none';
  scroller.style.scrollBehavior = 'auto';

  const animate = (from, to, duration, done) => {
    const start = performance.now();
    const step = (now) => {
      if (cancelled) return;
      const t = Math.min(1, (now - start) / duration);
      scroller.scrollLeft = from + (to - from) * ease(t);
      if (t < 1) frame = requestAnimationFrame(step);
      else done();
    };
    frame = requestAnimationFrame(step);
  };

  animate(0, distance, OUT_MS, () => {
    setTimeout(() => {
      if (cancelled) return;
      animate(distance, 0, BACK_MS, () => {
        if (!cancelled) restore();
      });
    }, HOLD_MS);
  });
}

function whenVisible(el, callback) {
  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      setTimeout(callback, START_DELAY_MS);
    },
    { threshold: 0.6 }
  );
  observer.observe(el);
}

function init() {
  if (!window.matchMedia(MOBILE_QUERY).matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const grid = document.querySelector('.product-grid');
  if (grid) {
    const card = [...grid.querySelectorAll('.product-grid__item')].find((item) => item.offsetParent !== null);
    const slideshow = card?.querySelector('slideshow-component:not([disabled="true"])');
    const scroller = slideshow?.querySelector('slideshow-slides');
    if (scroller) whenVisible(scroller, () => peek(scroller));
  }

  const gallery = document.querySelector('.product-information__media slideshow-component:not([disabled="true"])');
  const gallerySlides = gallery?.querySelector('slideshow-slides');
  if (gallerySlides) whenVisible(gallerySlides, () => peek(gallerySlides));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
